export const en = {
    'try-later': 'An error has occurred. Please try again.'
};
